export interface GlobalConfig {
  EMAIL_VALIDATOR_URL: any;
  PHONE_VALIDATOR_URL: any;
  AUTOLIST_API_URL: any;
  DEALER_PAGES_API_URL: any;
  COMPARISONS_API_URL: any;
  CONTENT_API_URL: any;
  LOOKUP_API_URL: any;
  GOOGLE_OAUTH_CLIENT_ID: any;
  COGNITO_IDENTITY_POOL_ID: any;
  NODE_ENV: any;
  GOOGLE_MAPS_API_KEY: any;
  REDIS_URL: any;
  AUTH_ENABLED: any;
  AUTH_TOKEN_GENERATOR_URL: any;
  HOST: any;
  DISABLE_EVENTS: any;
  DEBUG_EVENTS: any;
  EVENTS_KINESIS_STREAM_NAME: any;
  EVENTS_KINESIS_ENDPOINT: any;
  IMAGE_TAG: any;
  GOOGLE_ADWORDS_CONVERSION_ID_NEW: any;
  GOOGLE_ADWORDS_CONVERSION_ID_OLD: any;
  FIREBASE_API_KEY: any;
  FIREBASE_AUTH_DOMAIN: any;
  FIREBASE_DATABASE_URL: any;
  FIREBASE_PROJECT_ID: any;
  FIREBASE_APP_ID: any;
  FIREBASE_MEASUREMENT_ID: any;
  OPTIMIZELY_LIB_KEY: any;
}

export function getEnvVar(key: string): string | boolean | undefined {
  const envVal = process.env[key];
  if (typeof envVal !== 'string') {
    return undefined;
  }

  // Handle boolean-like strings
  if (envVal.toLowerCase() === 'true') return true;
  if (envVal.toLowerCase() === 'false') return false;

  try {
    const parsed = JSON.parse(envVal);
    if (typeof parsed === 'object' && parsed !== null) {
      return Object.values(parsed)[0] as string;
    }
    return envVal;
  } catch (error) {
    return envVal;
  }
}

export function getGlobalConfig(): GlobalConfig {
  if (typeof window !== 'undefined') {
    // eslint-disable-next-line no-underscore-dangle
    return window.__ENV__ as GlobalConfig;
  }

  return {
    EMAIL_VALIDATOR_URL: getEnvVar('EMAIL_VALIDATOR_URL'),
    PHONE_VALIDATOR_URL: getEnvVar('PHONE_VALIDATOR_URL'),
    AUTOLIST_API_URL: getEnvVar('AUTOLIST_API_URL'),
    DEALER_PAGES_API_URL: getEnvVar('DEALER_PAGES_API_URL'),
    COMPARISONS_API_URL: getEnvVar('COMPARISONS_API_URL'),
    CONTENT_API_URL: getEnvVar('CONTENT_API_URL'),
    LOOKUP_API_URL: getEnvVar('LOOKUP_API_URL'),
    GOOGLE_OAUTH_CLIENT_ID: getEnvVar('GOOGLE_OAUTH_CLIENT_ID'),
    COGNITO_IDENTITY_POOL_ID: getEnvVar('COGNITO_IDENTITY_POOL_ID'),
    NODE_ENV: getEnvVar('NODE_ENV'),
    GOOGLE_MAPS_API_KEY: getEnvVar('GOOGLE_MAPS_API_KEY'),
    REDIS_URL: getEnvVar('REDIS_URL'),
    AUTH_ENABLED: getEnvVar('AUTH_ENABLED'),
    AUTH_TOKEN_GENERATOR_URL: getEnvVar('AUTH_TOKEN_GENERATOR_URL'),
    HOST: getEnvVar('HOST'),
    DISABLE_EVENTS: getEnvVar('DISABLE_EVENTS'),
    DEBUG_EVENTS: getEnvVar('DEBUG_EVENTS'),
    EVENTS_KINESIS_STREAM_NAME: getEnvVar('EVENTS_KINESIS_STREAM_NAME'),
    EVENTS_KINESIS_ENDPOINT: getEnvVar('EVENTS_KINESIS_ENDPOINT'),
    IMAGE_TAG: getEnvVar('IMAGE_TAG'),
    GOOGLE_ADWORDS_CONVERSION_ID_NEW: getEnvVar('GOOGLE_ADWORDS_CONVERSION_ID_NEW'),
    GOOGLE_ADWORDS_CONVERSION_ID_OLD: getEnvVar('GOOGLE_ADWORDS_CONVERSION_ID_OLD'),
    FIREBASE_API_KEY: getEnvVar('FIREBASE_API_KEY'),
    FIREBASE_AUTH_DOMAIN: getEnvVar('FIREBASE_AUTH_DOMAIN'),
    FIREBASE_DATABASE_URL: getEnvVar('FIREBASE_DATABASE_URL'),
    FIREBASE_PROJECT_ID: getEnvVar('FIREBASE_PROJECT_ID'),
    FIREBASE_APP_ID: getEnvVar('FIREBASE_APP_ID'),
    FIREBASE_MEASUREMENT_ID: getEnvVar('FIREBASE_MEASUREMENT_ID'),
    OPTIMIZELY_LIB_KEY: getEnvVar('OPTIMIZELY_LIB_KEY'),
  };
}
